<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p style="font-size:10.5pt; line-height:150%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">额度合同编号：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">【</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">】</span>
          </p>
          <p style="font-size:10.5pt; line-height:150%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="font-size:10.5pt; line-height:150%; margin:0pt 0pt 10pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款额度合同</span>
          </p>
          <p style="font-size:10.5pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">特别提醒：在您签订本合同时，您已知悉并理解本合同的全部内容，同意向贷款人吉林亿联银行股份有限公司申请</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">额度</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款人同意向您提供额度借款，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">具体借款信息以本合同项下借款合同所载信息为准。借款合同是本合同组成部分之一，具有同等的法律效力。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">尊敬的客户，为充分维护您的合法权益，请您在签署本合同前，务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，限制、免责条款可能以加黑加粗的形式提示您注意。如您对本合同内容有任何疑问，请您暂停后续操作</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您可</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">通过贷款人和/或贷款人线上服务平台、客户服务</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">电话</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">等进行咨询了解后再决定是否使用本服务。</span>
          </p>
          <p style="line-height:18pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本合同由正文、附件以及不时发布的相关服务页面、账单、借据、借款合同、指引、说明和介绍（以下统称“规则文件”）等共同组成，共同构成完整的信贷服务协议、若规则文件与本合同约定不一致，应以规则文件为准。根据业务实际，规则文件可能会被适时修改，请您及时关注和了解。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本合同由您和贷款人共同签署。如您对本合同及本合同项下单笔贷款有任何异议，请拨打</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">客户服务电话</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold; text-decoration:underline">【95396】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">进行咨询、投诉。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第一条 定义</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.</span>
            <span style="font-family:宋体; font-size:10.5pt">1</span>
            <span style="font-family:宋体; font-size:10.5pt">线上服务平台：指您向贷款人提出贷款申请、查看额度、提款申请等操作的在线或APP等应用平台</span>
            <span style="font-family:宋体; font-size:10.5pt">，</span>
            <span style="font-family:宋体; font-size:10.5pt">包括但不限于</span>
            <span style="font-family:宋体; font-size:10.5pt">吉林亿联银行股份有限公司</span>
            <span style="font-family:宋体; font-size:10.5pt">、</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【 </span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline"> </span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline"> 】</span>
            <span style="font-family:宋体; font-size:10.5pt">等APP/H5链接/小程序等</span>
            <span style="font-family:宋体; font-size:10.5pt">。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.</span>
            <span style="font-family:宋体; font-size:10.5pt">2</span>
            <span style="font-family:宋体; font-size:10.5pt">本合同所称借款额度</span>
            <span style="font-family:宋体; font-size:10.5pt">/授信额度</span>
            <span style="font-family:宋体; font-size:10.5pt">，系指在本合同约定的额度有效期间内，由贷款人向借款人提供的人民币贷款的本金余额的最高限额。在额度有效期间内，借款人对借款额度可以循环使用，只要借款人未偿还的本合同项下的借款本金余额不超过借款额度，借款人可以连续申请借款，单笔借款的次数和金额不受限制，但借款人所申请的借款金额与借款人未偿还的本合同项下的借款本金余额之和不得超过借款额度。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.3</span>
            <span style="font-family:宋体; font-size:10.5pt">本合同所称人民币额度借款，系指按本合同约定使用借款额度所发生的借款。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1.4</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">授信额度有效期：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">是一个不中断的连续期间，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">指在授信额度内，您可向贷款人申请贷款的</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">期间</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">。本合同初始授信额度有效期为自本合同生效之日起</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">；授信额度有效期届满前，贷款人有权再次核定您的信用额度，评估通过后，授信有效期可从到期之日起延长一年。在额度有效期间内发生的单笔借款，其履行期限届满日不受额度有效期间是否届满的限制。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">在额度有效期终止时，未支用的借款额度自动失效。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">单笔借款期限系指自单笔借款提款日起至约定的还款之日止的期间。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.</span>
            <span style="font-family:宋体; font-size:10.5pt">5</span>
            <span style="font-family:宋体; font-size:10.5pt">可使用授信额度：是指当期您可以使用的额度。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">可使用额度＝授信额度－额度项下您已经支取且尚未结清的单笔借款剩余本金之和</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.</span>
            <span style="font-family:宋体; font-size:10.5pt">6</span>
            <span style="font-family:宋体; font-size:10.5pt">提款申请：您可向贷款人发出提款的支付申请，逐笔向贷款人申请贷款资金提取。贷款人有权根据您的风险状况或经营情况单方调整您使用贷款的提款（支付）限额（包括但不限于当日可发放总规模限额、单笔限额、每日限额和每月限额）及提款笔数。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1.</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">7</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">代扣还款：指为偿还本合同项下应付款项的目的，您无条件不可撤销地同意并授权贷款人持续向还款账户开户行、有权的第三方支付机构发送代扣指令，由相关银行或第三方支付机构直接将您还款账户的款项划扣至贷款人账户，用于偿还您在贷款人处全部债务直至清偿完毕，且贷款人有权将同一还款日的多笔贷款应还款额合为一笔或分成特定金额，分笔、分批发出代扣指令。您承诺前述代扣指令视同您本人作出。代扣时间、金额等指令以贷款人通知为准。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.</span>
            <span style="font-family:宋体; font-size:10.5pt">8</span>
            <span style="font-family:宋体; font-size:10.5pt">逾期：指借款人未按照约定的还款日（含宽限期（若有））向贷款人足额偿还已到期款项，包括但不限于合同约定还款日、加速到期日等。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1.9借款/贷款：本合同中，借款、贷款为同一含义。贷款人指借款/贷款资金提供方，即借款关系中的出借人。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第二条 基本信息</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">贷款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">：吉林亿联银行股份有限公司</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">人</span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">证件类型：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">证件号码：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">手机号码：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">借款用途：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">授信额度：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
            <span style="font-family:宋体; font-size:10.5pt">元</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">合同签署日期：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt">】</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第三条 合同的生效</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本合同经您</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">通过线上服务平台</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">点击“同意”、“确认”、“确认无误，下一步”等按钮或以勾选等其他方式确认（具体以线上服务平台实际操作为准）即视为您已完全理解并同意本合同全部条款（包括权利义务、责任免除、限制责任等），视为</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您与贷款人一致同意本合同以数据电文形式订立并认同其效力，您同意并授权线上服务平台在您点击“同意”、“确认”、“确认无误，下一步”等按钮或以勾选等其他方式确认（具体以线上服务平台实际操作为准）后调用您的电子签章在本合同上盖章，本合同</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">经签署后即对您和贷款人产生法律效力</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第四条 贷款申请</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">4.1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">您须亲自通过线上服务平台向贷款人提出借款申请，在签约前须确认并保证您同时满足以下条件，并承诺在本合同有效期内始终有效：</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24.25pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（1）您具有签订和履行本合同的民事权利能力和行为能力</span>
            <span style="font-family:宋体; font-size:10.5pt">，</span>
            <span style="font-family:宋体; font-size:10.5pt">已充分理解本合同条款内容，签署本合同系您真实意思表示。本合同构成对您具有约束力的协议，贷款人可以根据合同条款要求您履约或对您执行；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24.25pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（2）您签订本合同已获得所有必需的授权或批准，签订和履行本合同不违反您作为签约一方的任何协议以及相关法律法规的规定，与您应承担的其他合同项下的义务均无抵触；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24.25pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（3）您具有真实有效的身份证明，信用良好，有足够的偿债能力归还本合同项下的贷款本息及其他应付款项；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24.25pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（4）您提供给贷款人的所有文件和资料都是真实、准确、完整和有效的，不存在虚假记载、重大遗漏或误导性陈述；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24.25pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（5）本贷款的收还款账户为您所有并使用</span>
            <span style="font-family:宋体; font-size:10.5pt">，</span>
            <span style="font-family:宋体; font-size:10.5pt">或者为合同约定用途的交易对象所有并使用</span>
            <span style="font-family:宋体; font-size:10.5pt">；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24.25pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（6）您确认，贷款人已提请您特别注意本合同中有关您权利义务的全部条款，并应您的要求对该等条款作了相应的说明。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">4.2您应妥善保管您账号、密码、常用手机设备（含手机号码）、与贷款人账户绑定的手机号码、手机校验码及支付密码等信息，您应确保不向任何人泄露您的以上信息。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">对于因账号或密码泄露所致的损失，由您自行承担。如您发现有他人冒用或盗用您的前述信息或其他未经您合法授权之情形时，您应立即以本协议所示联系方式通知贷款人，要求贷款人暂停本服务。同时，您理解贷款人对您的请求采取行动需要合理期限，在此之前若您遭受损失或您的请求不在合理范围内，除法律明确规定或贷款人存在过错外，由此造成的损失将由您自行承担。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">4.3您保证向贷款人提供的所有申请信息是真实、完整、准确、合法、有效的，并授权贷款人向有关机构或单位（包括但不限于中国人民银行个人信用信息基础数据库、合法的征信机构、公安机关、公积金、社保、税务、民政等）查询或确认您使用本服务所必要的个人身份信息及信用信息（包括但不限于不良信息）。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">4.4贷款人有权依据您的资信情况综合自主决定是否受理您的借款申请及核定您的信用额度，且在核定您的信用额度后，贷款人有权根据掌握的您的信用情况或认定的风险管控因素或其他正当理由，随时调整您的信用额度（包括但不限于调低、调高或者中止、终止）。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">4.5贷款人核定的您的信用额度并不构成贷款人对您的授信承诺，信用额度项下具体提款业务，您应逐笔在授信额度有效期内及可使用授信额度内向贷款人申请提款，贷款人有权根据您的当期信用及贷款人当期可贷款资金规模自主决定是否向您发放额度项下单笔贷款以及具体贷款金额。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第五条 额度的使用、提款</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">5.1您应保证在安全环境下通过各种媒介使用本信用额度，否则您须对非安全环境下，本信用额度在互联网或其它媒介上使用所导致的风险和损失自行负责。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5.2</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您应确保妥善保管并不向任何人泄露交易密码，对于因密码泄露所致的损失，由您自行承担。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5.3在额度有效期间和借款额度内，借款人可以根据需要逐笔申请借款，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">经贷款人审核同意并经借款人确认后，贷款人按约定发放贷款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">双方办理相应的手续。单笔借款的金额、利率、期限、用途以经您确认的借款合同所载信息为准。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5.4您电子确认的交易凭证以及依据交易密码等电子数据信息办理的各类结算交易和信用额度提取、还款交易所产生的电子信息记录，均视为该项交易的有效凭证。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">5.5本信用额度项下单笔贷款只能用于</span>
            <span style="font-family:宋体; font-size:10.5pt">本合同约定用途</span>
            <span style="font-family:宋体; font-size:10.5pt">，</span>
            <span style="font-family:宋体; font-size:10.5pt">不得擅自改变借款用途或将借款挪作他用，</span>
            <span style="font-family:宋体; font-size:10.5pt">不得用于以下用途，</span>
            <span style="font-family:宋体; font-size:10.5pt">因违法违规或违反本合同约定用途使用贷款资金引起的一切后果由您承担：</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（1）购房及偿还住房抵押贷款；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（2）股票、债券、期货、金融衍生产品和资产管理产品等投资；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（3）固定资产、股本权益性投资；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（4）法律法规禁止的其他用途。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">5.6本额度项下单笔贷款采用自主支付或受托支付。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（1）本额度项下单笔贷款采用自主支付的，</span>
            <span style="font-family:宋体; font-size:10.5pt">您应符合相关法律法规规定可以自主支付的情形并取得贷款人同意，</span>
            <span style="font-family:宋体; font-size:10.5pt">贷款人根据您的提款申请将贷款资金直接</span>
            <span style="font-family:宋体; font-size:10.5pt">或者通过有支付结算资质的持牌机构</span>
            <span style="font-family:宋体; font-size:10.5pt">发放到您</span>
            <span style="font-family:宋体; font-size:10.5pt">指定</span>
            <span style="font-family:宋体; font-size:10.5pt">的账户上，并由您通过取现、转账、支付等方式自主支付给符合贷款申请时约定用途的交易对象。贷款人有权变更您对本额度的自主支付提款次数及单笔提款金额上限与下限，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-style:normal; text-transform:none">通过包括但不限于借款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-style:normal; text-transform:none">平台系统提示、</span>
            <span style="font-family:宋体; font-size:10.5pt; font-style:normal; text-transform:none">公告、电话、短信、电子邮件、其他即时通讯工具等方式</span>
            <span style="font-family:宋体; font-size:10.5pt; font-style:normal; text-transform:none">进行</span>
            <span style="font-family:宋体; font-size:10.5pt; font-style:normal; text-transform:none">通知</span>
            <span style="font-family:宋体; font-size:10.5pt; font-style:normal; text-transform:none">，而</span>
            <span style="font-family:宋体; font-size:10.5pt">无需另行取得您的同意。您应定期报告或告知贷款人贷款资金支付情况</span>
            <span style="font-family:宋体; font-size:10.5pt">，</span>
            <span style="font-family:宋体; font-size:10.5pt">并应根据贷款人的要求向贷款人提供符合本合同约定用途的相关贷款使用支付凭证（包括但不限于收据、发票、</span>
            <span style="font-family:宋体; font-size:10.5pt">交易资料、合同、发票、划款凭证、支付结算凭证或者贷款人要求的其他资料</span>
            <span style="font-family:宋体; font-size:10.5pt">等）</span>
            <span style="font-family:宋体; font-size:10.5pt">，贷款人有权通过账户分析、凭证查验、现场调查等方式核查贷款支付是否符合约定用途。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（2）本额度项下单笔贷款采用受托支付的，贷款人根据您的的提款申请和支付委托，</span>
            <span style="font-family:宋体; font-size:10.5pt">将本合同项下所申请的贷款款项直接</span>
            <span style="font-family:宋体; font-size:10.5pt">或者通过有支付结算资质的持牌机构最终支付给本合同约定用途的交易对象。</span>
            <span style="font-family:宋体; font-size:10.5pt">您确认贷款人将贷款资金划转至您指定交易对象账户后即视为贷款人履行了贷款发放义务，您须履行本合同约定偿还该笔贷款产生的所有债务，您不得否认与贷款人的借贷关系。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">无论采取受托支付还是自主支付，贷款资金一旦进入贷款发放账户即视为</span>
            <span style="font-family:宋体; font-size:10.5pt">贷款人</span>
            <span style="font-family:宋体; font-size:10.5pt">已履行放款义务。您应确保贷款发放账户状况正常（包括但不限于未被有权机关冻结等）。贷款资金进入贷款发放账户后发生的被有权机关冻结、划扣等风险、责任及损失，均</span>
            <span style="font-family:宋体; font-size:10.5pt">由</span>
            <span style="font-family:宋体; font-size:10.5pt">您方承担</span>
            <span style="font-family:宋体; font-size:10.5pt">。</span>
            <span style="font-family:宋体; font-size:10.5pt">具体支付方式及相关变更或触发变更的条件等以</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">经</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">确认的借款合同所载信息为准</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5.7贷款人放款时，将所发放的贷款资金直接划入双方在</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款合同</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">中约定的账户</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">或者其他您指定的账户</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。您应向贷款人提供准确的账户信息，因您提供的账户信息有误或状态异常，或因所提供账户的开户银行系统延误或故障、人行系统延误或故障等原因导致贷款人发放的贷款未能在约定的贷款起始日当日支付至您指定账户的，贷款人不承担责任。因上述原因导致贷款人放款失败的，您需重新申请提款。因您提供的账户信息错误，给贷款人造成损失的，您应承担赔偿责任。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">5.8</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">如因线上服务平台或本合同项下贷款相关的其他网络系统、收款账户受限等原因导致贷款人实际发放的贷款金额小于约定贷款金额的，您同意贷款人有权选择将贷款资金回收并终止本次支用申请、通知您更换收款账户、或通过贷款平台系统规则视情况将剩余款项补发至您收款账户等措施。请您关注放款情况，如您仍需贷款，您可在贷款平台重新提交申请。借款人可以对小于约定贷款金额部分继续申请支用，贷款人审批同意并放款后的贷款金额以累计发放金额为准，利息分别计算。如发生由于线上服务平台或本合同项下贷款相关的其他网络系统原因、贷款人系统原因或放款通路问题导致贷款人重复放款或者实际放款金额大于约定贷款的，您同意最终的贷款金额以本合同第一条约定的贷款金额为准。同时，请您充分理解并同意授权贷款人直接从您的还款账户中对多发放的或者重复发放的款项进行划回扣收，如贷款人未能成功扣收的，贷款人有权要求您就多发放的或者重复放款金额部分进行返还。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5.9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得利用本信用额度进行偷逃税款、逃废债务、套取现金、洗钱及其他违法犯罪活动，若您在使用本信用额度过程中出现监管机关规定的或贷款人依其主观判断认定的风险特征时，贷款人有权不经任何形式的事先通知或事先确认而随时中止或终止您对本信用额度的使用，您有义务积极协助贷款人识别相关风险，并承担因此所产生的损失。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第六条 利率</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">6.1本合同项下贷款执行利率</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">固定不变</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">按单利计算</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，以您在提款过程中经您电子确认的借款合同为准。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款年利率基于全国银行间同业拆借中心公布的贷款市场报价利率（LPR）加/减点形成。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在本合同约定的借款期限内，双方执行本合同确定的利率，如遇贷款市场报价利率调整，仍执行本合同利率。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">6.2</span>
            <span style="font-family:宋体; font-size:10.5pt">您使用</span>
            <span style="font-family:宋体; font-size:10.5pt">本合同项下</span>
            <span style="font-family:宋体; font-size:10.5pt">的额度</span>
            <span style="font-family:宋体; font-size:10.5pt">贷款</span>
            <span style="font-family:宋体; font-size:10.5pt">时</span>
            <span style="font-family:宋体; font-size:10.5pt">，贷款人将自贷款成功发放之日（从贷款人处转出）起计收利息至清偿日止，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">单笔贷款利率将以在您的提款过程中经您电子确认的借款合同为准。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">6.3您任何一期未及时足额归还借款本息即视为逾期，从逾期之日起对逾期贷款金额按本合同项下借款合同中约定的利率加收</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">50</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">%计收罚息，直至清偿逾期本息为止；对不能按时支付的利息，贷款人有权按罚息利率计收复利。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">6.4您未按各具体合同约定用途（以经您电子确认的借款合同中记载的用途为准）使用贷款的，贷款人有权对您违约使用部分贷款自该部分贷款成功发放之日按日在约定执行利率水平上加收</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">50</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">】</span>
            <span style="font-family:宋体; font-size:10.5pt">%计收罚息，直至贷款本息清偿完毕为止。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">6.5贷款人有权修改或新增利息收取标准，标准修改或新增后将在贷款人提供的线上服务平台进行公告，若您不同意修改或新增费用项目或标准，可停止申请新的贷款，您之前申请的贷款利息标准不受影响。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第七条 还款</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.1您应主动查询您账户信用额度的交易明细以确认交易内容。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款人所保存的本信用额度项下的交易记录，均为本额度使用的真实凭据，对您具有约束力。您不得以未收到对账单或未看到交易明细为由否认额度资金使用行为或交易款项。</span>
          </p>
          <p style="line-height:18pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.2</span>
            <span style="font-family:宋体; font-size:10.5pt">本合同项下单笔</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">的还款方式为下述方式其中之一，</span>
            <span style="font-family:宋体; font-size:10.5pt">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt">适用的还款方式以</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">经</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">确认的借款合同所载信息为准</span>
            <span style="font-family:宋体; font-size:10.5pt">，具体计算方式为：</span>
          </p>
          <p style="line-height:18pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.2.1</span>
            <span style="font-family:宋体; font-size:10.5pt">按月等额本息还款：即按贷款人要求，每月以固定金额偿还</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">本息，</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">到期日归还剩余本金和利息；</span>
          </p>
          <p style="line-height:18pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.2.2</span>
            <span style="font-family:宋体; font-size:10.5pt">按月等额本金还款：即按贷款人要求，每月以固定金额偿还</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">本金，并偿付当月实际产生利息，</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">到期日归还剩余本金和利息；</span>
          </p>
          <p style="line-height:18pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.2.3</span>
            <span style="font-family:宋体; font-size:10.5pt">到期一次性还本付息：即</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">到期日，一次性归还</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">本金及相应利息；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.2.4</span>
            <span style="font-family:宋体; font-size:10.5pt">按月还息到期一次性还本：即每月偿付当月实际产生的利息，</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">到期日归还全部</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">本金及剩余利息。</span>
          </p>
          <p style="line-height:18pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.3您应在每笔贷款的还款日</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline"> </span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">】</span>
            <span style="font-family:宋体; font-size:10.5pt">前归还当期应还款金额，还款日期以您提款过程中经您电子确认的借款合同信息及贷款人系统生成的电子信息记录为准。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.4还款方式分为主动还款或自动还款：</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（1）主动还款：您可登录线上服务平台主动向贷款人偿还借款本息及应付款项。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（2）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">自动还款（代扣还款）：您需在约定的还款日前将应还款项足额存入您的还款账户，您同意并授权还款账户开户行或第三方</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">有支付结算资质的持牌</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">机构接受贷款人委托从您</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">指定</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的还款账户</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">或其他您已签署生效的借款合同等法律文本约定的还款来源</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">中扣收本合同项下的贷款本息及其他应付款项。</span>
            <span style="font-family:宋体; font-size:10.5pt">您承诺前述代扣指令视同您本人作出。代扣的全部责任由您承担。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（3）您在此确认和授权，当您的账户余额不足时，贷款人有权降低代扣额度以及多次分笔通过还款账户开户行或第三方</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">有支付结算资质的持牌机构</span>
            <span style="font-family:宋体; font-size:10.5pt">发出代扣指令。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（4）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">不可撤销的授权贷款人或第三方支付机构接受贷款人的委托从</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的亿联银行账户或与亿联银行账户绑定的其他银行借记账户中扣收相应款项用于清偿借款本息及其他应付款项。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">）上述自动还款的目的是为了方便</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">还款，避免</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">因工作繁忙造成还款疏漏，同时也为了保护贷款人的合法权益。但请</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">知晓，其可能受系统、技术、网络、合作机构等各类因素的限制而造成扣款失败；因此，请</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">密切注意还款提示及结果，若出现自动扣款失败，请及时主动还款，避免因延误还款导致借款逾期。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">6</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">）若因</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">原因（包括但不限于还款账户余额</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">不满足</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">线上服务</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">平台展示的借款人当期应还还款计划金额</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">、账户状态异常、账户额度限制等）造成自动扣款失败，逾期未清偿任何款项将影响您的征信记录，由此产生的逾期后果由借款人自行承担。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">7.5</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">还款顺序：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款人扣收款项按照先</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">近</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">期、后</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">远</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">期和先</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">复利</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（如有）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">、罚息、利息、</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">后本金的顺序进行；如贷款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">逾期</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">90天以上且您支付的款项不足以偿还您欠贷款人的到期债务的，扣收款项的顺序为：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本金、利息</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">、罚息、复利（如有）、违约金（如有）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">但贷款人有权根据</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的信用状况和贷款人的风险政策单方面变更前述扣款顺序，并通过</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">线上服务平台</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">或电话或短信形式通知</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">7.6在您未清偿所有贷款本金及利息前，您在贷款期间应始终维持还款账户状态正常,不得变更、注销您的还款账户。如遇特殊情况，经贷款人审批通过后可变更您的还款账户，但贷款功能会受到限制。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">7.7</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您有权申请提前结清贷款，但在贷款发放当日不能提前结清。当有多笔未结清贷款时，贷款人有权限定您提前结清的借款合同顺序及金额下限，具体以贷款人受理您的提前还款申请后的终审结果为准，终审结果将在线上服务平台向您展示。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第八条 </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">承诺与保证</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">8</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">额度有效</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">期内，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">若借款人的基本信息，如通讯地址、电子邮件地址、手机号码、还款账户等发生变更的、或借款人的经济状况、还款能力出现不利变化的，借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">应在发生或可能发生之日起7个工作日内通过</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">线上</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">服务平台</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">或贷款人网站（或APP、微信公众号）或客服电话提交相关资料通知贷款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人变更后的基本信息仍然受本合同其他条款的约束，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款人有权根据具体</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">经济状况、还款能力等</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">情况决定</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">随时调整</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的信用额度（包括但不限于调低、调高或者中止、终止）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">8.2</span>
            <span style="font-family:宋体; font-size:10.5pt">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt">保证根据贷款人的要求向贷款人提供符合本合同约定用途的相关</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">资金</span>
            <span style="font-family:宋体; font-size:10.5pt">使用</span>
            <span style="font-family:宋体; font-size:10.5pt">记录和资料</span>
            <span style="font-family:宋体; font-size:10.5pt">（包括但不限于</span>
            <span style="font-family:宋体; font-size:10.5pt">交易资料、合同、发票、划款凭证、支付结算凭证或者贷款人要求的其他资料</span>
            <span style="font-family:宋体; font-size:10.5pt">）。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">8.3</span>
            <span style="font-family:宋体; font-size:10.5pt">如有任何损害或可能损害贷款人在本合同项下权益的事实发生或可能发生，</span>
            <span style="font-family:宋体; font-size:10.5pt">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt">应尽力采取补救措施并毫不迟延地通知贷款人。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">8.4借款人愿意妥善保管借款人的用户名、密码、数字证书、与账户绑定的手机动态验证码以及个人身份资料等重要信息，勿向其他人泄露。在线上服务平台上，前述账户的操作行为即视为借款人本人的行为，如开通服务、申请授信、申请使用借款资金、查询记录、进行还款、变更基本信息等，借款人将承担该等行为的相应法律后果。除使用密码等常用校验方式外，借款人亦认可贷款人及其合作机构可根据交易惯例及其他可验证借款人身份及意思表示的方式（如生物识别方式），确认借款人使用信贷服务的意愿，借款人不会仅以未使用密码等验证手段为由拒绝承认使用借款资金或还款。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">8.5</span>
            <span style="font-family:宋体; font-size:10.5pt">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt">承诺配合贷款人进行</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">支付管理、贷后管理及相关检查，包括但不限于接受贷款人对本合同项下</span>
            <span style="font-family:宋体; font-size:10.5pt">借款</span>
            <span style="font-family:宋体; font-size:10.5pt">使用情况和</span>
            <span style="font-family:宋体; font-size:10.5pt">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt">财务活动情况进行监督和检查，并为贷款人的前述监督和检查提供工作方便。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">8.6</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">不得利用本</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">金额进行偷逃税款、逃废债务、套取现金、洗钱及其他违法犯罪活动，若</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在使用本</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">金额过程中出现监管机关规定的或贷款人依其主观判断认定的风险特征时，贷款人有权不经任何形式的事先通知或事先确认而中止或终止</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">对本</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">金额的使用，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">有义务积</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">极协助贷款人识别相关风险，并承担因此所产生的损失。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">8.7</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在借款申请过程中向贷款人或</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">线上服务平台</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">提供第三方联系人信息或者第三方其他相关信息的，应当确保已经明确告知该第三方，并取得该第三方的明确同意，贷款人或</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">线上服务平台</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">获取的该第三方联系人信息或第三方其他相关信息，将仅用于审核</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的借款资质及对</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">进行贷后管理的合理且必要范围内（比如</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">逾期或通过其他途径无法正常联系</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">时，通过该第三方进行协助）。如因</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">未事先通知第三方并取得其同意导致产生投诉、纠纷或其他损失的，责任和损失均由</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">承担。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第九条 </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">违约条款</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.1下列事件之一即构成或视为您在本合同项下违约：</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（1）您未按本合同约定的用途使用贷款或将资金用于禁止领域；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（2）您未按本合同规定按时足额偿还贷款本息或其他应付款项；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（3）您明确表示或以自己的行为表明将不履行本合同项下的义务；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（4）您向贷款人提供虚假的信息；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（5）您在履行与贷款人或其他金融机构签订的其他合同时有违约行为；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（6）您存在已经或可能转移资产，以逃避债务的风险；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（7）您可能或已经发生影响偿债能力的情形（包括但不限于工作调整，收入降低、失业、重大疾病、拖欠其他债务、承担重大负债等</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">以及借款人的财产被依法查封、冻结、扣押或者监管，已经或可能影响借款人在本合同项下义务的履行</span>
            <span style="font-family:宋体; font-size:10.5pt">）；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（8）您违反本合同其他约定</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">或者未遵守承诺事项的</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（9）其他对贷款人债权产生严重不利影响的事件或行为。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.2发生违约事件时，贷款人有权采取以下一种或多种措施，且不承担任何责任：</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（1）要求您限期纠正违约行为；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（2）停止向您发放任何贷款；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（3）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">调低、冻结或终止借款人借款额度；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（</span>
            <span style="font-family:宋体; font-size:10.5pt">4</span>
            <span style="font-family:宋体; font-size:10.5pt">）要求您提前归还已发放的全部贷款本金并结清利息及其他应付款项；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（</span>
            <span style="font-family:宋体; font-size:10.5pt">5</span>
            <span style="font-family:宋体; font-size:10.5pt">）根据贷款风险状况调整贷款金额、期限与利率；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（</span>
            <span style="font-family:宋体; font-size:10.5pt">6</span>
            <span style="font-family:宋体; font-size:10.5pt">）以合法手段追偿贷款（包括但不限于委托债务催讨公司、律师事务所等其他第三方机构代为追讨，申请相关部门进行调查、向法院提起诉讼等）；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（</span>
            <span style="font-family:宋体; font-size:10.5pt">7</span>
            <span style="font-family:宋体; font-size:10.5pt">）宣布本合同项下您未偿还的贷款提前到期，委托还款账户开户行或第三方支付机构从您的还款账户或在贷款人任何营业机构开立的账户中扣收您应偿付的贷款本金、利息、罚息、复利以及其他应付款项；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">8</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">解除合同；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:32.4pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">）根据法律法规规定或本合同约定有权采取的其他违约救济措施。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.3您同意贷款人有权在进行催收和追索债务等工作时，将您的身份信息、联络信息及您拖欠本合同项下债务的相关信息提供给第三方（包括但不限于律师事务所和催收机构）。贷款人将督促该等第三方妥善保管、保密和谨慎使用前述信息，不得用作委托催收和追索债务以外的其他用途，以及不得以任何违法的方式进行催收和追索债务。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.4贷款人因向您催收欠款及实现债权而产生的一切费用（包括但不限于诉讼费、仲裁费、财产保全费、公告费、执行费、拍卖费、变卖费、鉴定费、律师费、保全担保费、</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">催收费用、</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">办案费用等），均由您承担。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.5</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">出现下列任一状况致使贷款人无法履行本协议项下约定的</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，不视为贷款人违约，由各方根据法律法规规定承担相关责任，您可重新申请借款，该状况包括但不限于： </span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（1）在</span>
            <span style="font-family:宋体; font-size:10.5pt">经事前合理公告通知的线上服务平台等与信贷服务相关的系统停机</span>
            <span style="font-family:宋体; font-size:10.5pt">维护</span>
            <span style="font-family:宋体; font-size:10.5pt">或升级</span>
            <span style="font-family:宋体; font-size:10.5pt">期间；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（2）</span>
            <span style="font-family:宋体; font-size:10.5pt">您使用的电子设备软硬件或通信线路、供电线路出现故障的</span>
            <span style="font-family:宋体; font-size:10.5pt">；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">（3）因风、地震、海啸、洪水、</span>
            <span style="font-family:宋体; font-size:10.5pt">雷</span>
            <span style="font-family:宋体; font-size:10.5pt">电、战争、恐怖袭击</span>
            <span style="font-family:宋体; font-size:10.5pt">或国家/地区进入紧急状态</span>
            <span style="font-family:宋体; font-size:10.5pt">等不可抗力</span>
            <span style="font-family:宋体; font-size:10.5pt">原因</span>
            <span style="font-family:宋体; font-size:10.5pt">；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（4）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">您操作不当或通过非贷款人授权或认可的方式使用信贷服务的；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">5</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">因病毒、木马、恶意程序攻击、网络拥堵、通讯故障、电力故障、电信设备故障、还款账户开户行、第三方支付机构服务瑕疵或政府行为等原因</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">尽管有前述约定，贷款人将采取合理行动积极促使服务恢复正常。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9.6</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">因国家有关部门颁布</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">变更</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的法律、法规、规章、规定、指引、通知（包括口头通知）、政策及其他规范性文件</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">等，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">导致贷款人不能</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">提供约定服务的不视为违约，各方可根据相关规定变更协议内容、中止或提前终止本协议。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9.7您理解本协议所涉服务有赖于贷款人及其合作伙伴系统的准确运行及操作。若出现上述系统差错、故障或其他原因引发了展示错误、您或贷款人或贷款人的合作机构等不当获利等情形的，贷款人可以自行或者通过第三方采取更正差错、扣划款项、暂停服务等适当纠正措施。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9.8本协议的签订可能会调用您的数字证书进行电子签章。您理解，调用数字证书进行电子签章可能因为数据传输而发生电子签章时间晚于您实际确认本协议时间的情况，您认可此种情况下，本协议以及借款合同的签约信息及签约时间等均以系统记录为准，请您在相关服务页面及时关注及查看。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">十</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">条 合同变更与解除条款</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">10</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.1本合同生效后，除本合同另有约定外，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在您与贷款人尚有争议，或者信贷服务仍在继续使用中的情况下，您无法终止本协议</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。贷款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">可能因风险控制、政策变化以及本协议约定的其他相关情形等原因而暂停或终止为您提供服务，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">并要求您在指定期限内偿还本合同项下贷款本息和费用（如有）。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <a name="_Hlk133236215">
              <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">10.2</span>
              <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">除本合另有约定外，任一方如需修改本合同内容，需征得相对方同意并另行签订补充协议。</span>
            </a>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="-aw-bookmark-end:_Hlk133236215"></span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第十</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">一</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">条 合同权利义务的转让 </span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">.1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解信贷服务的特殊性，按照法律规定，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">未经贷款人书面同意，您不得将本合同项下的权利和义务转让给任何第三方。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">.2</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在不对您使用信贷服务造成不利影响的前提下，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">贷款人有权将其在本合同项下的权利和义务全部或部分转让给第三方，且贷款人的转让行为无须征得您的同意。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.3您知悉并同意，若贷款人发生前述转让行为，该等转让行为可由贷款人通过包括但不限于借款平台公告、借款平台站内信、信函、电话、短信、电子邮件或您提供的其他即时通讯工具账号等方式通知</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您，您</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">知悉并同意前述任意一种通知方式。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第十</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">二</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">条 通知与送达条款</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">2</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">.1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">除法律法规另有强制性规定外，本协议履行过程中，我们以邮寄方式传递给您的书面通知，按照您提供的通讯地址交邮后的第三个自然日即视为送达；书面通知的形式还包括在服务页面公告或信息推送、向您发送电子邮件、APP推送信息、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下，发送当日即视为送达。我们可决定以前述一种或几种形式书面通知您。我们以多种方式向您发送通知的，通知送达时间以最先送达的为准。</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">12.2</span>
            <span style="font-family:宋体; font-size:10.5pt">您同意对于因合同争议引起的任何纠纷，法院或仲裁机构可以手机短信或电子邮件、中国审判流程信息公开网、全国统一送达平台、微法院、支付宝、微信等现代化即时通讯方式（以下简称“电子送达方式”）及/或邮寄、公告送达方式向您送达法律文书（包括但不限于诉讼文书）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1</span>
            <span style="font-family:宋体; font-size:10.5pt">2</span>
            <span style="font-family:宋体; font-size:10.5pt">.</span>
            <span style="font-family:宋体; font-size:10.5pt">3</span>
            <span style="font-family:宋体; font-size:10.5pt">您指定</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">接收法律文书的手机号码或电子邮箱为协议约定的手机号码或电子邮箱</span>
            <span style="font-family:宋体; font-size:10.5pt">，以上手机号码或电子邮箱作为您本人的电子送达地址之一，法院或仲裁机构向前述任一号码或邮箱发出法律文书即视为送达，发送当日即为送达之日。</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">2</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">.</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">4</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">您指定邮寄地址为您</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">协议约定的</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">邮寄地址或者身份证地址，采用邮寄方式送达，签收之日为送达日，若快递被退回的，退回之日为送达日</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">。</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">2</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您同意法院/仲裁机构可采取以上一种或多种送达方式向您送达法律文书，法院/仲裁机构采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1</span>
            <span style="font-family:宋体; font-size:10.5pt">2</span>
            <span style="font-family:宋体; font-size:10.5pt">.</span>
            <span style="font-family:宋体; font-size:10.5pt">6</span>
            <span style="font-family:宋体; font-size:10.5pt">您确认的上述送达方式适用于各个司法阶段，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">包括但不限于仲裁、一审、二审、再审、执行以及督促程序（含支付令送达）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold; text-decoration:underline">同时适用双方非诉时各类通知、协议等文件的送达</span>
            <span style="font-family:宋体; font-size:10.5pt">。</span>
          </p>
          <p style="background-color:#ffffff; line-height:18pt; margin:5pt 0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1</span>
            <span style="font-family:宋体; font-size:10.5pt">2</span>
            <span style="font-family:宋体; font-size:10.5pt">.</span>
            <span style="font-family:宋体; font-size:10.5pt">7</span>
            <span style="font-family:宋体; font-size:10.5pt">若您上述送达地址有变更，您应当及时书面通知贷款人更新相关信息，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您未书面履行告知义务的，前述您指定的送达地址仍视为有效送达地址。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">2</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">.</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">8</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您已阅读本确认书所有条款，并保证上述送达地址是准确、有效的；如果因提供的送达地址不确切，或不及时告知变更后的地址、手机号码，或您拒绝签收等原因，导致法律文书未能被您实际接收的，邮寄送达的，以发出第三日视为送达之日；直接送达的，送达人当场在送达回证上记明情况之日视为送达之日；履行送达地址及手机号码变更通知义务的，以变更后的送达地址及手机号码为有效送达地址。对于上述您指定的地址，法院或仲裁机构进行送达时可直接邮寄送达或电子送达，即使您未能收到法院或仲裁机构邮寄送达或电子送达的法律文书，由于前述约定，您也同意视为送达。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">第十</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">三</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">条 附则</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1</span>
            <span style="font-family:宋体; font-size:10.5pt">3</span>
            <span style="font-family:宋体; font-size:10.5pt">.1线上服务平台所公布的服务收费标准、单笔借款合同及电子补充协议、</span>
            <span style="font-family:宋体; font-size:10.5pt">您在线上服务平台填写的所有信息、与本贷款相关的网络页面信息及</span>
            <span style="font-family:宋体; font-size:10.5pt">附件是本合同不可分割的部分，与本合同具有同等法律效力。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">3</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">.2您在向贷款人提供的资料及信息（包括但不限于姓名、国籍、住所地、工作单位、联系电话、身份证件或者身份证明文件的号码、有效期等身份信息）发生变更的，应在信息发生变更之日起7日内通过贷款人提供的线上服务平台更新相关信息；</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款人就本合同给予其他方的任何通知、要求或其他函件，一经发送到您向贷款人提供的信息中所示的地址</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（包括</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">身份证上</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">的地址）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，即视为已送达，本条所述书面通知的形式还包括但不限于贷款人采用在线上服务平台公告、向借款人发送电子邮件、线上服务平台站内信息、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下发送当日即视为送达。贷款人有权决定以前述任何一种或几种形式书面通知借款人。贷款人以多种方式向借款人发送通知的，通知送达时间以最先送达的为准。因您不及时变更信息而引起的责任及产生的损失，由您自行承担，贷款人有权因此停止为您发放新的贷款。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt">1</span>
            <span style="font-family:宋体; font-size:10.5pt">3</span>
            <span style="font-family:宋体; font-size:10.5pt">.3本合同及本合同相关协议、电子借款合同或附件（如有）已经经过第三方存证机构进行电子证据固化并保存，可以作为争议解决中的证据使用。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">1</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">3</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">.4管辖及法律适用</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（1）本合同适用中华人民共和国法律（基于本合同之目的，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">为避免歧义，</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在此不包括香港</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">特别行政区</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">、澳门特别行政区和台湾地区法律），并按其解释。有关本合同的一切争议可通过友好协商解决；协商不成的，任何一方当事人均可选择以下第</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold; text-decoration:underline">【 1/2 】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">种方式解决</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1、仲裁，提交至【哈尔滨仲裁委员会】，按照申请仲裁时该委员会现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">2、诉讼，提交下列之一的人民法院以诉讼方式解决（含申请支付令、电子支付令）：</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">①合同签订地（贷款人服务器托管地）；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">②贷款人所在地；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">③被告所在地；</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">④若本合同项下债权发生了一次或多次转让、第三人因担保获得了对借款人的追偿权、第三人因担保获得对借款人的追偿权后又将该权利进行一次或多次转让的,则双方确认由本合同项下债权的最终受让方所在地法院管辖。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（2）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在此期间，为减轻各方争议解决成本，加快争议解决效率，各方同意采用视听传输技术等在线审理方式（如同步在线审理，异步在线审理等）方式开庭。争议标的额（包括贷款本金、利息、罚息及其他违约金等）超过受理法院所在的省、自治区、直辖市上年度就业人员年平均工资百分之五十但在二倍以下的，各方同意司法机关适用小额诉讼程序，以及采用在线诉讼方式（包括但不限于电子支付令、诉前调解、在线庭审等）解决争议。</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">3</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">）</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在争议解决期间，若该争议不影响本合同其他条款的履行，则其他条款应继续履行。</span>
          </p>
          <p style="line-height:18pt; margin:6pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="line-height:18pt; margin:0pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">贷款人签章：</span>
            <span style="font-family:宋体; font-size:10.5pt">【</span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt"> 】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">借款人签章：</span>
            <span style="font-family:宋体; font-size:10.5pt">【 </span>
            <span style="font-family:宋体; font-size:10.5pt"> </span>
            <span style="font-family:宋体; font-size:10.5pt"> 】</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
